import { render, staticRenderFns } from "./checkout-navigation-buttons.vue?vue&type=template&id=fd899172&scoped=true"
import script from "./checkout-navigation-buttons.vue?vue&type=script&lang=js"
export * from "./checkout-navigation-buttons.vue?vue&type=script&lang=js"
import style0 from "./checkout-navigation-buttons.vue?vue&type=style&index=0&id=fd899172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd899172",
  null
  
)

export default component.exports